<div class="tt-c-summary-dim tt-c-summary-dim-rating tt-u-spacing--sm">
  <div class="tt-c-summary-dim__heading tt-u-align-center">{{ratingDisplay}}</div>
  <div class="tt-c-summary-dim-rating__bar-wrap">
    <div class="tt-c-summary-dim-rating__bar"><span class="tt-c-summary-dim-rating__progress" :style="{ width: ratingPercentage}"></span></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/reviews-summary/summary-dim-rating.html